export const SET_TAGS = 'setTags';
export const RESET_STATE = 'resetState';
